module.exports = __webpack_public_path__ + "static/media/pragmatic7000.21fc4aa9.webp";